export default {
  LOAD_GENERAL_COMPETENCY_EVENT_LIST_START: 'LoadGeneralCompetencyEventListStart',
  LOAD_GENERAL_COMPETENCY_EVENT_LIST_END: 'LoadGeneralCompetencyEventListEnd',
  FILTER_GENERAL_COMPETENCY_EVENT_LIST: 'FilterGeneralCompetencyEventList',
  SORT_GENERAL_COMPETENCY_EVENT_LIST: 'SortGeneralCompetencyEventList',
  TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG: 'ToggleGeneralCompetencyEventListConfirmDialog',
  LOAD_GENERAL_COMPETENCY_EVENT_LIST_STATUSES: 'LoadGeneralCompetencyEventListStatuses',
  SET_CONFIRM_DIALOG_ERROR: 'SetGeneralCompetencyEventListConfirmDialogError'
};
